import FactoredInvoiceList from '../components/factoredinvoice/List.vue';

export default [
  { name: 'FactoredInvoiceList', path: '/factored_invoices/', component: FactoredInvoiceList }
];



// WEBPACK FOOTER //
// ./src/routes/factoredinvoice.js